import type { FaireProductEntity } from "../../entity_types/product";

export const p_live_algae_cooking_club_algae_cooking_oil: FaireProductEntity = {
  token: "p_live_algae_cooking_club_algae_cooking_oil",
  type: "product",
  name: "Algae Cooking Oil",
  brandToken: "b_live_algae_cooking_club",
  brandName: "Algae Cooking Club",
  imageUrl:
    "https://cdn.faire.com/fastly/926b0331734e1c7533529c9f49e4a281b1ebd549f3a7b2b5c8290e2a758b33e3.png?bg-color=FFFFFF&fit=crop&format=jpg&height=400&width=400",
  priceDollars: 8.5,
  msrpDollars: 17,
  description:
    "Algae Cooking Club algae cooking oil used in Live Shopping mocks.",
  categoryTokens: ["cat_food-drink"],
  tags: ["live-shopping", "bestseller", "oils"],
  isBestseller: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "live-shopping-migration",
  },
};
